import { dataDollarCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDollarCircleSolid = /*#__PURE__*/createIcon(dataDollarCircleSolid)
export default IconDollarCircleSolid
